import {
  aBigIntDataPoint,
  anInsightCountsByStatusDataPoint,
  anInsightStatus,
  mockHudRadarQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockHudRadarQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightCountsByStatus: [anInsightCountsByStatusDataPoint()],
          insightStatuses: [anInsightStatus()],
          recordCounts: [aBigIntDataPoint()],
          signalCounts: [aBigIntDataPoint()],
        },
      });
    }
  ),
];
